import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-related-post',
  templateUrl: './related-post.component.html',
  styleUrls: ['./related-post.component.scss'],
})
export class RelatedPostComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
